import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface RemovePermissionInput { roleId: string; permissionId: string; }
export function createRemovePermissionFromRoleUseCase({ membershipRepository }: Deps) {
  return async function removePermissionFromRole(input: RemovePermissionInput): Promise<void> {
    return membershipRepository.removePermissionFromRole(input);
  };
}
